import { MessageContentType } from "wukongimjssdk"

// 定义 PartType 枚举对应的对象（JS 中无原生枚举，用对象模拟）
const PartType = {
    text: 0,    // 普通文本
    emoji: 1,   // emoji
    mention: 2, // @
    link: 3     // 链接
};
// 冻结对象防止被修改，更贴近 TS 枚举的不可变性
Object.freeze(PartType);

// 定义 BubblePosition 枚举对应的对象
const BubblePosition = {
    unknown: 0,
    first: 1,   // 第一个
    middle: 2,  // 中间
    last: 3,    // 最后一个
    single: 4   // 单独
};
Object.freeze(BubblePosition);

// 定义 Part 类
class Part {
    /**
     * 构造函数
     * @param {number} type - 类型（对应 PartType 的值）
     * @param {string} text - 文本内容
     * @param {any} [data] - 可选的附加数据
     */
    constructor(type, text, data) {
        // 严格赋值，替代 TS 的 ! 非空断言
        this.type = type;
        this.text = text;
        // 可选参数，有值则赋值
        if (data !== undefined) {
            this.data = data;
        }
    }
}

// 解析获得消息@
export function parseMention(content) {
  // 非文本类型直接返回空数组
  if (content.contentType !== MessageContentType.text) {
    return [];
  }

  const textContent = content;
  let text = textContent.text || '';
  const mention = content.mention;

  // 没有提及用户ID时，返回仅包含文本片段的数组
  if (!mention?.uids || mention.uids.length <= 0) {
    return [new Part(PartType.text, text)];
  }

  let parts = [];
  let i = 0;

  while (text.length > 0) {
    // 匹配@开头的提及内容（支持中文、字母、数字、下划线）
    const mentionMatchResult = text.match(/@([\w\u4e00-\u9fa5])+/m);
    let index = mentionMatchResult?.index ?? -1; // 简化undefined判断

    // 无匹配的@内容，将剩余文本作为文本片段并结束循环
    if (!mentionMatchResult || index === -1) {
      parts.push(new Part(PartType.text, text));
      break;
    }

    // @前面有普通文本，先拆分普通文本片段
    if (index > 0) {
      parts.push(new Part(PartType.text, text.substring(0, index)));
    }

    // 构建提及片段的用户ID数据
    let data = {};
    if (i < mention.uids.length) {
      data = {
        "uid": mention.uids[i]
      };
    }

    // 添加提及片段
    parts.push(new Part(
      PartType.mention,
      text.substr(index, mentionMatchResult[0].length),
      data
    ));

    // 截取剩余文本继续处理
    text = text.substring(index + mentionMatchResult[0].length);
    i++;
  }

  return parts;
}

export { PartType, BubblePosition, Part };